// Components
import Certificates from './components/Certificates';
import Material from './components/Material';
import Header from './components/Header';
import Hero from './components/Hero';
import Timeline from './components/Timeline';
import TimelineSingle from './components/TimelineSingle';

// Types
import { Period, Document } from './types/entities';

const educationPeriods: Period[] = [
	{
        location: 'Fondazione Bruno Kessler and University of Trento',
        from: '2022',
        to: '2026',
        title: 'PhD Student',
        desc: 'ELLIS PhD Student at DH, LanD and MobS unities at Fondazione Bruno Kessler (Trento). Working on Multi-Party Conversations, both from the NLP and Network Analysis perspective. Interested also in online toxic phenomena. Get in touch if you are interested!',
        link: 'https://dh.fbk.eu/',        
	link_name: 'DH group',
	link1: 'https://land.fbk.eu/',
	link1_name: 'LanD group',
	link2: 'https://mobs.fbk.eu/',
	link2_name: 'MobS group',
	link3: 'https://ellis.eu/phd-postdoc',
	link3_name: 'ELLIS PhD and Postdoc program'
	},
    {
        location: 'University of Padua',
        from: '2020',
        to: '2022',
        title: 'MSc in Computer Engineering - AI & Robotics',
        desc: ' Machine/Deep Learning, Natural Languague Processing, Graph Analysis, Big Data Computing, Computer Vision, Operation Research, Intelligent Robotics and NeuroRobotics',
        link: 'https://en.didattica.unipd.it/off/2020/LM/IN/IN2547',
        link_name: 'Computer Engineering at UniPD'
    },
    {
        location: 'University of Padua',
        from: '2017',
        to: '2020',
        title: 'BSc in Information Engineering',
        desc: 'Relevant subjects: Calculus, General Physics, Data and Algorithms, Programming, Telecommunications, Electronics, Automatic Controls, Systems and Modeling, Data and Signal Analysis',
        link: 'https://en.didattica.unipd.it/off/2017/LT/IN/IN0513',
        link_name: 'Information Engineering at UniPD'
    }
    
    
];

const experiencePeriods: Period[] = [
{
        location: 'CAIDAS, University of Würzburg',
        from: 'October 2024',
        to: 'March 2025',
        title: 'Visiting PhD Student',
        desc: 'Research Visiting at the Chair for Natural Language Processing research group in Würzburg (PI Goran Glavaš).',
        link: 'https://www.caidas.uni-wuerzburg.de/en/nlp/',
        link_name: 'NLP at CAIDAS'
    },
{
        location: 'University of Trento',
        from: 'March 2023',
        to: 'June 2024',
        title: 'Teaching Assistant',
        desc: 'Assistant at the courses of Applied Natural Language Processing (with prof. Jacopo Staiano, MSc in Artificial Intelligent Systems and MSc in Computer Science).',
        link: 'httpsç//webapps.unitn.it/du/it/Persona/PER0247066/Didattica',
        link_name: 'UniTN page'
    },
{
        location: 'Bocconi University',
        from: 'June 2022',
        to: 'August 2022',
        title: 'Research Intern',
        desc: 'Internship period at MilaNLP group at Bocconi University, around hate speech detection and more general NLP works.',
        link: 'https://milanlproc.github.io',
        link_name: 'MilaNLP'
    },
{
        location: 'University of Padua',
        from: 'February 2022',
        to: 'June 2022',
        title: 'Research Training',
        desc: 'In this period I am trying to applying techniques from NLP, Deep/Machine Learning and Graph Analysis, to predict social phenomena in Social Media Platforms. Doing it in the context of my Master Thesis Supervisors: prof. Giorgio Satta, prof. Fabio Vandin',
        link: 'https://www.dei.unipd.it',
        link_name: 'DEI UniPD'
    },
    {
        location: 'University of Padua',
        from: 'September 2021',
        to: 'July 2022',
        title: 'Teaching Assistant',
        desc: 'Assistant at the courses of Laboratory Programming, Artificial Intelligence (BSc in Computer Engineering) and Big Data Computing (MSc in Computer Engineering) at the University of Padua.',
        link: 'https://www.dei.unipd.it',
        link_name: 'DEI UniPD'
    }
        
];

const publicationPeriods: Period[] = [
{
        location: 'AAAI 2026',
        from: 'Jan 2026',
        to: '',
        title: 'Don’t Stop the Multi-Party! On Generating Synthetic Multi-Party Conversations with Constraints',
        desc: 'Nicolò Penzo, Marco Guerini, Bruno Lepri, Goran Glavaš, Sara Tonelli',
        link: 'https://arxiv.org/pdf/2502.13592',
        link_name: 'paper'
    },
	
	{
        location: 'TMLR',
        from: 'Nov 2025',
        to: '',
        title: 'I Want to Break Free! Anti-Social Behavior and Persuasion Ability of LLMs in Multi-Agent Settings with Social Hierarchy',
        desc: 'Gian Maria Campedelli, Nicolò Penzo, Massimo Stefan, Roberto Dessì, Marco Guerini, Bruno Lepri, Jacopo Staiano',
        link: 'https://openreview.net/pdf?id=FR76oM8eGD',
        link_name: 'paper'
    },
	{
        location: 'EMNLP 2024',
        from: 'Nov 2024',
        to: ' ',
        title: 'Do LLMs suffer from Multi-Party Hangover? A Diagnostic Approach to Addressee Recognition and Response Selection in Conversations',
        desc: 'Nicolò Penzo, Maryam Sajedinia, Bruno Lepri, Sara Tonelli, Marco Guerini',
        link: 'https://arxiv.org/abs/2409.18602',
        link_name: 'paper',
	link1: process.env.PUBLIC_URL + '/Penzo_poster_EMNLP2024.pdf',
	link1_name: 'poster',
	link2: process.env.PUBLIC_URL + '/Penzo_slides_EMNLP2024_update.pdf',
	link2_name: 'slides'
    },
    {
        location: 'EACL 2024',
        from: 'Mar 2024',
        to: ' ',
        title: 'Putting Context in Context: the Impact of Discussion Structure on Text Classification',
        desc: 'Nicolò Penzo, Antonio Longa, Bruno Lepri, Sara Tonelli, Marco Guerini',
        link: 'https://aclanthology.org/2024.eacl-long.108/',
        link_name: 'paper',
	link1: process.env.PUBLIC_URL + '/LTdayFBK.pdf',
	link1_name: 'poster',
	link2: process.env.PUBLIC_URL + '/eacl_pdf_presentation.pdf',
	link2_name: 'slides'
    },
{
        location: 'CLiC-it 2024',
        from: 'Dec 2024',
        to: ' ',
        title: 'Nesciun Lengaz Lascià Endò: Machine Translation for Fassa Ladin',
        desc: 'Giovanni Valer, Nicolò Penzo, Jacopo Staiano',
        link: 'https://www.staiano.net/pubs/clic_2024.pdf',
        link_name: 'paper',
	link1: process.env.PUBLIC_URL + '/ClicIT_2024.pdf',
	link1_name: 'poster'
    }
];


function App() {
    return (
        <div className='min-h-full px-2 md:px-12 py-8 text-gray-600'>
            <Header />
            <main className='max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8'>
                <Hero />
                <Timeline id='education' title='Education' periods={educationPeriods} />
                <Timeline id='experience' title='Experience' periods={experiencePeriods} />
	       <TimelineSingle id='publicationPeriods' title='Relevant Publications' periods={publicationPeriods} />
            </main>
        </div>
    );
}

export default App;
	